import React from 'react'
import { Button } from 'reactstrap';
import { FormIndications } from './FormIndications';
import { Dialog } from 'primereact/dialog';

export const ModalIndications = (props) => {

    const {

        method, modalTitle, loading, modal, closeDialog,
        saveCreate, handleInputChange, saveUpdate, saveDelete,
        id_exam_indication, indication, validaciones


    } = props;

    const footer = (
        <>
            <hr />


            <Button
                color="secondary"
                size="sm"
                disabled={loading}
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                {
                                    method === "create"
                                        ? "Guardando..."
                                        : "Actualizando..."
                                }
                            </>
                        )
                        : (
                            method === "create"
                                ? "Guardar"
                                : "Actualizar"
                        )
                }
            </Button>
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>
        </>
    );


    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            blockScroll
            footer={footer}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-clipboard f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v2`}
        >
            {
                method === "create"
                    ? <FormIndications
                        {...{ loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                    : (method === "update")

                        ?
                        <FormIndications
                            {...{
                                loading, handleInputChange, id_exam_indication, indication, validaciones, methodAction: saveUpdate,
                            }}
                        />
                        : null
            }
        </Dialog>

    )
}
